import { render } from "./MessageVideo.vue?vue&type=template&id=2090a3f7&scoped=true&ts=true"
import script from "./MessageVideo.vue?vue&type=script&lang=ts"
export * from "./MessageVideo.vue?vue&type=script&lang=ts"

import "./MessageVideo.vue?vue&type=style&index=0&id=2090a3f7&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2090a3f7"]])

export default __exports__